module.exports = {
  protocol: 'https',
  api_url: 'notes81.herokuapp.com/api',
  port: 'server port',
};